// extracted by mini-css-extract-plugin
export default {"advertWrapper":"X5kvwIet","advert":"_5JCWSySH","placeholder":"AdUnit_placeholder__+1R-I12o","background":"AdUnit_background__NT0ualB5","content":"AdUnit_content__urWzwYV-"};